import { render, staticRenderFns } from "./QuotasTable.vue?vue&type=template&id=18e01c5a&"
import script from "./QuotasTable.vue?vue&type=script&lang=js&"
export * from "./QuotasTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports